import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onExited"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useContext } from "react";
import { Toast } from "../../Toast";
import { ToastContext } from "../ToastContext";
import { jsx as _jsx } from "react/jsx-runtime";
export function useToasterState() {
  var _useContext = useContext(ToastContext),
      toasts = _useContext.toasts,
      removeToast = _useContext.removeToast;

  var toast = toasts[0];

  if (toast) {
    var message = toast.message,
        props = toast.props;

    var _ref = props || {},
        _onExited = _ref.onExited,
        rest = _objectWithoutProperties(_ref, _excluded);

    return /*#__PURE__*/_jsx(Toast, _objectSpread(_objectSpread({
      message: message
    }, rest), {}, {
      onExited: function onExited() {
        _onExited == null ? void 0 : _onExited();
        removeToast();
      }
    }));
  } else {
    return undefined;
  }
}